
import { defineComponent } from 'vue'
import { formatDate } from '@/helpers/commons/localeHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import QBEPreviewDialogDescriptor from './QBEPreviewDialogDescriptor.json'
import QBEDescriptor from '../../QBEDescriptor.json'

export default defineComponent({
    name: 'qbe-preview-dialog',
    components: { Column, DataTable },
    props: { id: { type: String }, queryPreviewData: { type: Object }, pagination: { type: Object }, entities: { type: Array }, selectedQuery: { type: Object, required: true } },
    emits: ['close', 'pageChanged'],
    data() {
        return {
            QBEPreviewDialogDescriptor,
            QBEDescriptor,
            columns: [] as any[],
            rows: [] as any[],
            lazyParams: {} as any,
            first: 0,
            loading: false
        }
    },
    watch: {
        queryPreviewData() {
            this.loadData()
        },
        pagination() {
            this.loadPagination()
        }
    },
    created() {
        this.loadData()
        this.loadPagination()
    },
    methods: {
        loadData() {
            if (this.queryPreviewData) {
                this.setPreviewColumns(this.queryPreviewData)
                this.rows = this.queryPreviewData.rows
            }
        },
        setPreviewColumns(data: any) {
            this.columns = []

            for (let i = 1; i < data.metaData?.fields?.length; i++) {
                const tempColumn = data.metaData?.fields[i]
                if (['timestamp', 'date'].includes(tempColumn.type)) {
                    const field = this.findField(tempColumn) as any
                    if (field) tempColumn.metawebDateFormat = field.format
                    if (!tempColumn.metawebDateFormat) {
                        this.setCalculatedFieldDateFormat(tempColumn, i - 1)
                    }
                }
                this.columns.push(data.metaData?.fields[i])
            }
        },
        setCalculatedFieldDateFormat(tempColumn: any, index: number) {
            if (!this.selectedQuery || !this.selectedQuery.fields) return
            if (this.selectedQuery.fields[index]) tempColumn.metawebDateFormat = this.selectedQuery.fields[index].id.format ?? 'L'
        },
        findField(column: any) {
            if (!this.entities) return

            let field = null

            for (let i = 0; i < this.entities.length; i++) {
                const tempEntity = this.entities[i] as any
                for (let j = 0; j < tempEntity.children.length; j++) {
                    if (tempEntity.children[j].attributes.field === column.header) {
                        field = tempEntity.children[j]
                        break
                    }
                }
            }

            return field
        },
        loadPagination() {
            this.lazyParams = this.pagination as any
            this.first = this.pagination?.start
        },
        onPage(event: any) {
            this.lazyParams = { paginationStart: event.first, paginationLimit: event.rows, paginationEnd: event.first + event.rows, size: this.lazyParams.size }
            this.$emit('pageChanged', this.lazyParams)
        },
        close() {
            this.$emit('close')
            this.first = 0
            this.lazyParams = {}
        },
        getFormattedDate(date: any, column: any) {
            if (!date) return null;
            const inputFormat = column.type === 'timestamp' ? 'DD/MM/YYYY HH:mm:ss.SSS' : 'DD/MM/YYYY'
            let format = undefined as string | undefined
            if (QBEDescriptor.admissibleDateFormats.includes(column.metawebDateFormat)) {
                format = column.metawebDateFormat
            }
            return formatDate(date, format, inputFormat)
        }
    }
})
